/**
 * The corporate-brand theme.
 *
 * Built from the five colours in the Corporate Brand Guidelines (p.22):
 * School bus Yellow `#ffde00`, Lochmara Blue `#007ac2`, White `#ffffff`,
 * Thunder Dark Grey `#241f21`, Manatee Grey `#8a8f9e`.
 *
 * It is a **light** theme on purpose. Those five were specified for a logo on
 * print and white surfaces, and only hold their contrast there — Lochmara Blue
 * manages 4.60:1 on white but drops to 4.01:1 on ATLAS's dark ground, under the
 * 4.5:1 AA floor. A dark "brand" theme would have to alter the brand colours to
 * be legible, which the guidelines forbid ("cannot be swapped, altered, or
 * changed in any way"). Staying light is what lets the values be exact.
 *
 * Two roles could not use a brand colour as-is, and both are documented at the
 * point of use below. Everything else is the brand hex, unmodified.
 */
export const chauvetCorporateTheme = {
    id: 'chauvet-corporate',
    label: 'Chauvet Corporate',
    description: 'The corporate brand palette — Lochmara Blue and School bus Yellow on white.',
    paletteMode: 'light',
    tokens: {
        app: { bg: '#f4f5f7', bgElevated: '#ffffff' },
        surface: {
            nav: '#ffffff',
            panel: '#ffffff',
            panelAlt: '#f4f5f7',
            input: '#ffffff',
        },
        border: {
            // Manatee Grey at low alpha — a hairline, never text, so its 3.23:1 on
            // white is irrelevant here.
            default: 'rgba(138, 143, 158, 0.32)',
            strong: 'rgba(0, 122, 194, 0.55)',
        },
        text: {
            primary: '#241f21', // Thunder Dark Grey — 16.24:1 on white
            // NOT Manatee Grey. Brand Manatee is 3.23:1 on white, which fails AA for
            // body text; this is Manatee darkened to 6.39:1. The only tinted value in
            // the palette besides the hover state.
            secondary: '#5a5f6b',
            disabled: '#8a8f9e', // Manatee Grey — 3.23:1, fine for disabled text
            inverse: '#ffffff',
        },
        action: {
            primary: '#007ac2', // Lochmara Blue — 4.60:1 on white, white-on-fill 4.60:1
            primaryHover: '#005f99', // Lochmara darkened for the hover state
            secondary: '#ffde00', // School bus Yellow — a FILL only; pair with dark text (12.14:1)
        },
        state: {
            success: '#0f7a52',
            warning: '#b25e00',
            error: '#c62828',
            info: '#007ac2', // the brand blue doubles as the info tone
        },
        data: {
            seriesA: '#007ac2', // Lochmara Blue
            seriesB: '#ffde00', // School bus Yellow
            seriesC: '#8a8f9e', // Manatee Grey
            seriesD: '#241f21', // Thunder Dark Grey
        },
        effect: {
            glow: 'rgba(0, 122, 194, 0.20)',
            shadow: '0 4px 12px -2px rgb(36 31 33 / 0.14), 0 2px 6px -2px rgb(36 31 33 / 0.09)',
        },
    },
};
//# sourceMappingURL=chauvet-corporate.js.map